import { render, staticRenderFns } from "./ProductSelectModal.vue?vue&type=template&id=4e1a0619&scoped=true"
import script from "./ProductSelectModal.vue?vue&type=script&lang=js"
export * from "./ProductSelectModal.vue?vue&type=script&lang=js"
import style0 from "./ProductSelectModal.vue?vue&type=style&index=0&id=4e1a0619&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e1a0619",
  null
  
)

export default component.exports